import isNil from 'lodash/isNil'

import { getMap } from 'utils/MapUtils'

// https://trello.com/c/IheyHfxX/2296-export-to-geotiff
// https://en.wikipedia.org/wiki/World_file
export default function (pixelWidth, pixelHeight) {
  const map = getMap()

  if (isNil(map)) {
    return []
  }

  const mapSizeResolutionPixels = [pixelWidth, pixelHeight] // map.getSize()
  // console.log('Canvas Pixel resolution W,H', mapSizeResolutionPixels)

  const view = map.getView()
  const extent = view.calculateExtent(map.getSize())
  // console.log('extent', extent)

  const widthMapUnitsX = extent[2] - extent[0]
  const widthMapUnitsY = extent[3] - extent[1]
  // console.log('Units W,H', widthMapUnitsX, widthMapUnitsY)

  const unitsPerPixelX = widthMapUnitsX / mapSizeResolutionPixels[0]
  const unitsPerPixelY = (widthMapUnitsY / mapSizeResolutionPixels[1]) * -1

  const worldfile = [unitsPerPixelX, 0, 0, unitsPerPixelY, extent[0], extent[3]]

  console.log(worldfile)

  return worldfile
}
